import React from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery';

class HTMLViewer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getHtmlOutput = this.getHtmlOutput.bind(this);
        this.isValueSet = this.isValueSet.bind(this);
        this.clearViewer = this.clearViewer.bind(this);
        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);

        this.state = {
            htmlOutput: null,
            logIdx: null,
            show: false
        };
    }
    clearViewer() {
        this.setState({
            htmlOutput: null
        });
    }
    hideHandler() {
        this.setState({ show: false });
    }
    showHandler() {
        this.setState({ show: true });
    }
    getHtmlOutput(logId) {
        if (logId) {
            var url = "/api/v1/extractions/" + this.props.currentExtraction?.id + "/batches/" + this.props.batchID + "/jobs/" + encodeURIComponent(logId) + "/html"
            $.get(url, res => {
                this.setState({
                    htmlOutput: res,
                    logIdx: logId,
                    show: true
                });
            });
            return;
        }
        if (!this.props.isJobOutputAvailable()) {
            return;
        }
        var url = "/api/v1/extractions/" + this.props.currentExtraction.id + "/batches/" + this.props.batchID + "/jobs/" + encodeURIComponent(this.props.activeJobId) + "/html"
        $.get(url, res => {
            this.setState({
                htmlOutput: res,
                show: true
            });
        });
    }
    isValueSet() {
        return this.state.htmlOutput != null && (this.props.row_id == null || this.state.logIdx == this.props.row_id)
    }
    render() {
        return (
            <div>
                <Button
                    variant="light"
                    onClick={() => this.getHtmlOutput(this.props.row_id)}
                >
                    Display HTML
                </Button>
                <div className="modal-container">
                    <Modal
                        show={this.state.show}
                        onHide={this.hideHandler}
                        centered
                        dialogClassName="asset-modal-wide"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title">
                                HTML Output
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.isValueSet() && (
                                <div style={{ position: 'relative' }}>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>Copy markup</Tooltip>}
                                    >
                                        <Button
                                            variant="link"
                                            onClick={() => navigator.clipboard.writeText(this.state.htmlOutput)}
                                            style={{
                                                position: 'absolute',
                                                top: '-25px',
                                                right: '5px',
                                                padding: '2px',
                                                fontSize: '12px',
                                                opacity: 0.8
                                            }}
                                        >
                                            📋
                                        </Button>
                                    </OverlayTrigger>
                                    <textarea
                                        readOnly
                                        value={this.state.htmlOutput}
                                        style={{
                                            width: '800px',
                                            height: '400px',
                                            fontFamily: 'monospace',
                                            padding: '8px',
                                            resize: 'none'
                                        }}
                                    />
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.hideHandler}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default HTMLViewer;